import { g as r } from "./global.js";
var e = Object.defineProperty,
  t = function t(_t, a) {
    try {
      e(r, _t, {
        value: a,
        configurable: !0,
        writable: !0
      });
    } catch (e) {
      r[_t] = a;
    }
    return a;
  };
export { t as d };